export const INICIAR_SESION = 'INICIAR_SESION';
export const ADD_TODO = 'ADD_TODO';
export const REMOVE_TODO = 'REMOVE_TODO';
export const UPDATE_TODO = 'UPDATE_TODO';
export const COMPLETE_TODO = 'COMPLETE_TODO';
export const ACTUALIZAR = 'ACTUALIZAR';
export const TRAER_TODOS = 'TRAER_TODOS';